type Props = {
  /** Client short name, e.g. "BASAC". Falls back to the product name alone. */
  organization?: string | undefined;
  /** Programme name, e.g. "Leadership Accelerator". */
  program?: string | undefined;
};

/**
 * The wordmark: mono, uppercase, teal with the instrument in ink.
 *
 * It names the client's programme rather than the vendor — a rater at BASAC is
 * answering their own organization's assessment, not visiting a supplier.
 */
export const Brand = ({ organization, program }: Props) => (
  <div className="px-0.5 pt-4 font-mono text-[11px] font-bold tracking-[0.14em] text-teal uppercase">
    {organization && <>{organization} · </>}
    {program ?? 'Leadership Accelerator'}
    <span className="text-ink"> · 360</span>
  </div>
);
